// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-33eef2c2] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3.75rem 0;\n}\n.container button[data-v-33eef2c2] {\n  width: 7.5rem;\n  height: 2.5rem;\n  margin: 0 1.25rem;\n}\n.icon[data-v-33eef2c2] {\n  margin-bottom: 1.25rem;\n}\n.p-text[data-v-33eef2c2] {\n  font-size: 1.25rem;\n  font-weight: 400;\n  color: #333333;\n  line-height: 3.125rem;\n  margin-bottom: 2.5rem;\n}", ""]);
// Exports
module.exports = exports;
